var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c(
      "div",
      { staticClass: "tabs-container" },
      [
        _c(
          "el-tabs",
          {
            staticStyle: { width: "100%", height: "100%" },
            attrs: { type: "card" },
            on: { "tab-click": _vm.handleTabClick },
            model: {
              value: _vm.activeTabName,
              callback: function($$v) {
                _vm.activeTabName = $$v
              },
              expression: "activeTabName"
            }
          },
          [
            _c(
              "el-tab-pane",
              {
                staticStyle: { width: "100%", height: "100%" },
                attrs: {
                  lazy: true,
                  label: _vm.$t("CargoMsg.CompanyCopy"),
                  name: "companyCopy"
                }
              },
              [
                _c("company-copy", {
                  ref: "companyCopy",
                  attrs: { "tab-title": _vm.$t("CargoMsg.CompanyCopy") }
                })
              ],
              1
            ),
            _c(
              "el-tab-pane",
              {
                staticStyle: { width: "100%", height: "100%" },
                attrs: {
                  lazy: true,
                  label: _vm.$t("CargoMsg.ChargeSchemeCopy"),
                  name: "chargeSchemeCopy"
                }
              },
              [
                _c("charge-scheme-copy", {
                  ref: "chargeSchemeCopy",
                  attrs: { "tab-title": _vm.$t("CargoMsg.ChargeSchemeCopy") }
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }